<template>
  <div>
    <!-- Header: Personal Info -->
    <div class="d-flex">
      <feather-icon icon="UserIcon" size="19" />
      <h4 class="mb-0 ml-50">Company Information</h4>
    </div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <!-- Form: Personal Info Form -->
      <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
        <b-row>
          
          <b-col cols="12" md="6">
              <span
                style="
                  margin-bottom: 0.2857rem;
                  color: #5e5873;
                  font-size: 0.857rem;
                "
                >Logo</span
              >
              <el-upload
                class="avatar-uploader"
                list-type="picture-card"
                ref="upload"
                :action="uploadUrl"
                :headers="headerObj"
                name="image_file"
                :file-list="fileList"
                multiple
                :limit="1"
                :data="userData"
                :on-change="onChange"
                :on-remove="toggleUpload"
                :before-remove="beforeRemove"
                :auto-upload="false"
                :class="{ hideUpload: !showUpload }"
              >
                <img
                  v-if="userData.image_url && false"
                  :src="userData.image_url"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </b-col>
            <b-col cols="12" md="6" v-if="userData.image_url">
              <img class="user-image" :src="userData.image_url" />
            </b-col>

          <!-- Field: Company ID -->
          <b-col cols="12" md="12">
            <b-form-group label="Company ID" label-for="id">
              <b-form-input id="id" v-model="userData.id" readonly />
            </b-form-group>
          </b-col>

          

          <!-- Field: Company Name -->
          <b-col cols="12" md="12">
            <validation-provider
              #default="validationContext"
              name="Company Name"
              rules="required"
            >
              <b-form-group label="Company Name" label-for="name">
                <b-form-input
                  id="name"
                  v-model="userData.name"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" md="12">
            <validation-provider
              #default="validationContext"
              name="Email"
              rules="required"
            >
              <b-form-group label="Email Address" label-for="email">
                <b-form-input
                  id="email"
                  v-model="userData.email"
                  placeholder="Email"
                  :state="getValidationState(validationContext)"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="12">
              <b-form-group
                class=""
                label="Address"
                label-for="address"
              >
                <b-form-input
                  id="address"
                  type="text"
                  v-model="userData.address"
                />
              </b-form-group>
          </b-col>

          <b-col cols="12" md="12">
              <b-form-group
                class=""
                label="Phone"
                label-for="phone"
              >
                <b-form-input
                  id="phone"
                  type="text"
                  v-model="userData.phone"
                />
              </b-form-group>
          </b-col>
          
          <b-col cols="12" md="12">
              <b-form-group
                class=""
                label="Database"
                label-for="db_database"
              >
                <b-form-input
                  id="db_database"
                  type="text"
                  v-model="userData.db_database"
                />
              </b-form-group>
          </b-col>

          <b-col cols="12" md="12">
              <b-form-group
                class=""
                label="Image Folder Name"
                label-for="folder_name"
              >
                <b-form-input
                  id="folder_name"
                  type="text"
                  v-model="userData.folder_name"
                  placeholder="對應圖片資料夾名稱"
                />
              </b-form-group>
          </b-col>

          <!-- Field: Description -->
          <b-col cols="12" md="12">
              <b-form-group
                class=""
                label="Description"
                label-for="description"
              >
                <quill-editor
                  id="description"
                  v-model="userData.description"
                  :options="editorOption"
                  class="border-bottom-0"
                />
                <div
                  id="quill-toolbar-description"
                  class="d-flex justify-content-start border-top-0 flex-wrap"
                >
                  <!-- Font formatting -->
                  <select class="ql-size">
                    <option value="small"></option>
                    <option selected></option>
                    <option value="large"></option>
                    <option value="huge"></option>
                  </select>

                  <!-- Text formatting -->
                  <button class="ql-bold" />
                  <button class="ql-italic" />
                  <button class="ql-underline" />
                  <button class="ql-strike" />

                  <!-- Colors -->
                  <select class="ql-color">
                    <option selected></option>
                    <option value="red"></option>
                    <option value="green"></option>
                    <option value="blue"></option>
                    <option value="orange"></option>
                    <option value="violet"></option>
                    <option value="#d0d1d2"></option>
                  </select>
                  <select class="ql-background">
                    <option selected></option>
                    <option value="red"></option>
                    <option value="green"></option>
                    <option value="blue"></option>
                    <option value="orange"></option>
                    <option value="violet"></option>
                    <option value="#d0d1d2"></option>
                  </select>

                  <!-- Lists -->
                  <button class="ql-list" value="ordered" />
                  <button class="ql-list" value="bullet" />

                  <!-- Alignment -->
                  <select class="ql-align">
                    <option selected></option>
                    <option value="center"></option>
                    <option value="right"></option>
                    <option value="justify"></option>
                  </select>

                  <!-- Links and media -->
                  <button class="ql-link" />
                  <button class="ql-image" />

                  <!-- Clear formatting -->
                  <button class="ql-clean" />
                </div>
              </b-form-group>
          </b-col>
        </b-row>

        <!-- Form: Personal Info Form -->
        <b-row class="mt-1">
          <b-col cols="12" md="12" v-if="userData.id == 0">
            <h4 class="mb-0">Password</h4>
            <hr />
          </b-col>
          <!-- Field: Password -->
          <b-col cols="12" md="6" v-if="userData.id == 0">
            <validation-provider
              #default="validationContext"
              name="Password"
              rules="required|min:8"
            >
              <b-form-group
                class="required"
                label="Password"
                label-for="password"
              >
                <b-form-input
                  id="password"
                  type="password"
                  :state="getValidationState(validationContext)"
                  v-model="userData.password"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- Field: Password Confirm -->
          <b-col cols="12" md="6" v-if="userData.id == 0">
            <validation-provider
              #default="validationContext"
              name="Password Confirm"
              rules="required|min:8|confirmed:Password"
            >
              <b-form-group
                class="required"
                label="Password Confirm"
                label-for="password_confirmation"
              >
                <b-form-input
                  id="password_confirmation"
                  type="password"
                  :state="getValidationState(validationContext)"
                  v-model="userData.password_confirmation"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <hr />

        <b-row>
          <b-col cols="12" md="6">
            <b-form-group label-for="is_active">
              <b-form-checkbox
                checked="true"
                v-model="userData.is_active"
                class="custom-control-success"
                name="check-button"
                switch
                inline
              />
              {{ userData.is_active ? "Enable" : "Disable" }}
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Button: Submit & Reset Button.-->
        <b-row class="mt-2">
          <b-col>
            <b-button
              variant="primary"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              type="submit"
            >
              Save
            </b-button>
         <!--    <b-button
              variant="outline-secondary"
              class="mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="resetData"
            >
              Reset
            </b-button> -->
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="hide"
            >
              Cancel
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormRadioGroup,
  BFormCheckboxGroup,
  BButton,
  BFormCheckbox,
  BFormInvalidFeedback,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, onMounted } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, alphaNum, email } from "@validations";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  directives: {
    Ripple,
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  mixins: [togglePasswordVisibility],
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    flatPickr,
    BFormInput,
    BFormTextarea,
    vSelect,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
  BInputGroup,
  BInputGroupAppend,
  quillEditor,
  },
  methods: {
    toggleUpload() {
      this.showUpload = !this.showUpload;
    },
    hide() {
      this.$router.replace("/users/list");
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "Save Changes",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();
          formData.append("file", this.userData.file);
          formData.append("id", this.userData.id);
          formData.append("name", this.userData.name);
          formData.append("email", this.userData.email);
          formData.append("address", this.userData.address);
          formData.append("phone", this.userData.phone);
          formData.append("description", this.userData.description);
          formData.append("is_active", this.userData.is_active? 1: 0);
          formData.append('db_database', this.userData.db_database)
          formData.append('folder_name', this.userData.folder_name)
          if(this.userData.id == 0)
          {
            formData.append("password", this.userData.password);
            formData.append("password_confirmation", this.userData.password_confirmation);
          }


          store
            .dispatch("app-user/updateUser", formData)
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.showUpload = true
              this.fileList = []
              if(this.userData.id == 0)
              {
                this.hide();
              }

            })
            .catch((error) => {
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const positionOptions = ref([]);
    const teamOptions = ref([]);

    const genderOptions = [
      { text: "Male", value: "m" },
      { text: "Female", value: "f" },
    ];

    const contactOptionsOptions = ["Email", "Message", "Phone"];

    const resetData = () => {
      emit("refetch-data");
    };
    const resetuserData = () => {
      props.clientData = JSON.parse(JSON.stringify({}));
    };
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetuserData);


    onMounted(() => {
      console.log(props.userData);
    });

    const uploadUrl = ref(process.env.VUE_APP_SERVICE_URL + "/banner");
    const headerObj = {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    };
    const upload = ref(null);
    const refInputEl = ref(null);
    const refPreviewEl = ref(null);
    const showUpload = ref(true);
    const fileList = ref([]);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        refPreviewEl.value.src = base64;
      }
    );

    const onChange = (file, fileLists) => {
      //fileList.value = fileLists;
      showUpload.value = !showUpload.value;
      props.userData.file = file.raw;
    };

    const beforeRemove = (file) => {
      props.userData.file = null;
    };

    const uploadSuccess = (res, file, fileList) => {
      emit("refetch-data");
      console.log('upload success')
    };

    const uploadFail = (err, file, fileList) => {
      //showMessage('Fail', err, 'HeartIcon', 'danger')
      console.log("upload Fail");
    };

    const editorOption = {
      modules: {
        toolbar: "#quill-toolbar-description",
      },
      placeholder: "Company Description",
    };

    return {
      genderOptions,
      contactOptionsOptions,
      positionOptions,
      teamOptions,
      resetData,
      refFormObserver,
      getValidationState,
      resetForm,
      resetuserData,
      refPreviewEl,
      upload,
      uploadUrl,
      uploadSuccess,
      uploadFail,
      onChange,
      headerObj,
      fileList,
      showUpload,
      beforeRemove,
      editorOption,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
.teamleader_selected {
  background: #110f6a;
  padding: 3px 10px;
  border-radius: 3px;
  color: white;
}
</style>
